import React from 'react';
import './user-info.scss';
import avt from '../../assets/images/avt.jpg';
import { useSelector } from 'react-redux';
import { Avatar } from '@material-ui/core';
const UserInfo = () => {
	const { travellerlogin, agentlogin } = useSelector((state) => state.user);
	return (
		<div className='user-info'>
			{/* <div className='user-info__img'>
				<img src={avt} alt='' width='50px' height='50px' />
			</div> */}
			<div className='user-info__name'>
				<span>
					{travellerlogin
						? travellerlogin &&
						  travellerlogin.result &&
						  travellerlogin.result.result &&
						  travellerlogin.result.result.name
						: agentlogin
						? agentlogin &&
						  agentlogin.result &&
						  agentlogin.result.result &&
						  agentlogin.result.result.name
						: ''}
				</span>
			</div>
		</div>
	);
};

export default UserInfo;
